document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.js-section-problem-and-benefits-block__button');
    const contents = document.querySelectorAll('.js-section-problem-and-benefits-block__content');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const target = this.getAttribute('data-target');

            // Deactivate all buttons and set their styles
            buttons.forEach(btn => {
                btn.classList.remove('active');
                btn.style.backgroundColor = '#ffffff'; // Set inactive button background to white
                btn.style.color = '#000000'; // Set inactive button text color to black
            });

            // Activate the clicked button and set its style
            this.classList.add('active');
            this.style.backgroundColor = '#000000'; // Set active button background to black
            this.style.color = '#ffffff'; // Set active button text color to white

            // Show the appropriate content based on the clicked button
            contents.forEach(content => {
                if (content.getAttribute('data-content') === target) {
                    content.classList.remove('d-none');
                } else {
                    content.classList.add('d-none');
                }
            });
        });
    });
});
